/* SplashStrong: animaciones de aparición + confianza en carrito lateral */
(function () {
  var root = document.documentElement;
  root.classList.add('ss-js');
  if (window.Shopify && window.Shopify.designMode) root.classList.add('ss-design');

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
    : null;

  function scan(scope) {
    (scope || document).querySelectorAll('.ss-reveal:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  function injectTrust() {
    var footer = document.querySelector('#CartDrawer .drawer__footer');
    var tpl = document.getElementById('ss-drawer-trust');
    if (footer && tpl && !footer.querySelector('.ss-trust')) footer.appendChild(tpl.content.cloneNode(true));
  }

  function init() {
    scan();
    injectTrust();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) new MutationObserver(injectTrust).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  /* Seguridad: si algo falla, mostrar todo tras 2.5s */
  setTimeout(function () { document.querySelectorAll('.ss-reveal:not(.is-in)').forEach(function (el) {
    var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add('is-in');
  }); }, 2500);
})();
